/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */

import { store } from 'redux/store';

import { getOperationDataForTax193 } from '../api/getOperationDataForTax193';

// Helper function to clean society name for filename
// Removes extra spaces and normalizes
const cleanSocietyName = (name) => {
  if (!name) return '';
  return name.replace(/\s+/g, ' ').trim();
};

// Format date as YYYYMMDD
const formatDateForFilename = (date) => {
  if (!date) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

  const dateObj = date instanceof Date ? date : new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

// Main Tax 193 file generator function
const generateTax193File = async ({
  operationId,
  shareholdersType,
  society,
  operation,
  fiscalYear,
}) => {
  try {
    let content = '';
    const societyId = society._id;

    const { headerRecord, detailContent, totalAmount, recordCount } =
      await store.dispatch(
        getOperationDataForTax193({
          fiscalYear,
          societyId,
          shareholdersType,
        })
      );

    if (!headerRecord || !detailContent) {
      throw new Error('No data available for Tax 193 generation');
    }

    content += `${headerRecord}\n`;
    content += detailContent;

    const year = operation?.date
      ? new Date(operation.date).getFullYear()
      : new Date().getFullYear();
    const societyName = cleanSocietyName(society?.name || '');
    const dateStr = formatDateForFilename(operation?.date);
    const filename = `RC${year}193 - ${societyName} - ${dateStr}.txt`;

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return {
      success: true,
      recordCount,
      totalAmount,
      filename,
    };
  } catch (error) {
    throw new Error(error);
  }
};

export { generateTax193File };
